import styled from 'styled-components'
import { AdjustColumns, Hr, Price } from '../../styles'
import { formatPrice, formatMoneyAmount } from '../../../../helpers/utils'
import {
  COUPON_TYPES,
  COUPON_TYPES_PRICE,
  COUPON_TYPES_TOTAL_PRICE,
  COUPON_TYPES_AMOUNT,
  COUPON_TYPES_UNIT,
} from '../../../../constants/couponType'

const getSlipsDate = (slips) => {
  if (slips.length <= 0) return '-'

  try {
    const sendDate = slips[0].transaction[0].createdAt
    const sendSlipDate = new Date(sendDate).toLocaleString('TH-th')
    return sendSlipDate ? sendSlipDate : '-'
  } catch (error) {
    return '-'
  }
}

const Order = ({ order, slips }) => {
  const { couponItem, createdAt, updatedAt, approvedAt, status, totalPrice, vat } = order
  const buyAt = new Date(createdAt).toLocaleString('TH-th')
  const sendDate = getSlipsDate(slips)
  const sendSlipDate = sendDate.toLocaleString('TH-th')
  const canceledDate = new Date(updatedAt).toLocaleString('TH-th')
  const approvedDate = new Date(approvedAt).toLocaleString('TH-th')
  const { price: couponPrice, quantity: couponQuantity, type: couponType } = couponItem || {}

  return (
    <>
      <Title>ข้อมูลการสั่งซื้อ</Title>
      <Hr />
      <AdjustColumns>
        <div>ประเภทคูปอง</div>
        <div>{COUPON_TYPES[couponType] || '-'}</div>
      </AdjustColumns>
      <AdjustColumns>
        <div>วันที่ซื้อ</div>
        <div>{buyAt}</div>
      </AdjustColumns>
      <AdjustColumns>
        <div>วันที่ส่งหลักฐาน</div>
        <div>{sendSlipDate}</div>
      </AdjustColumns>
      {status === 'CANCEL' && (
        <AdjustColumns>
          <div>วันที่ยกเลิกคำสั่งซื้อ</div>
          <div>{canceledDate}</div>
        </AdjustColumns>
      )}
      {status === 'SUCCESS' && (
        <AdjustColumns>
          <div>วันที่ยืนยันคำสั่งซื้อ</div>
          <div>{approvedDate}</div>
        </AdjustColumns>
      )}
      <AdjustColumns>
        <div>{COUPON_TYPES_AMOUNT[couponType]}</div>
        <div>{`${couponQuantity} ${COUPON_TYPES_UNIT[couponType]}`}</div>
      </AdjustColumns>
      <AdjustColumns>
        <div>{COUPON_TYPES_PRICE[couponType]}</div>
        <div>{couponPrice} บาท</div>
      </AdjustColumns>
      {vat && (
        <AdjustColumns>
          <div>{COUPON_TYPES_TOTAL_PRICE[couponType]}</div>
          <div>{formatMoneyAmount(totalPrice - vat)} บาท</div>
        </AdjustColumns>
      )}
      {vat && (
        <AdjustColumns>
          <div>ภาษีมูลค่าเพิ่ม (VAT 7%)</div>
          <div>{formatMoneyAmount(vat)} บาท</div>
        </AdjustColumns>
      )}
      <AdjustColumns>
        <div>ยอดรวม</div>
        <Price>{formatPrice(totalPrice)} บาท</Price>
      </AdjustColumns>
    </>
  )
}

export default Order

const Title = styled.h4`
  margin-top: 20px;
`
